// react
import { useContext } from 'react';

// context
import { ContextBeneficiaryDocuments } from '../Beneficiary.context';

// mui
import { Container, Grid } from '@mui/material';

// tables
import { TableDocuments } from '../../../tables/cards/TableDocuments/TableDocuments';

export const Documents = () => {
	// context
	const { documents, isLoadingDocuments, paginationDocuments, refetchDocuments } = useContext(
		ContextBeneficiaryDocuments
	);

	return (
		<section>
			<Container maxWidth={false}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<TableDocuments
							documents={documents}
							entityType="BENEFICIARY"
							frame="BENEFICIARY"
							isLoading={isLoadingDocuments}
							pagination={paginationDocuments}
							refetchDocuments={refetchDocuments}
						/>
					</Grid>
				</Grid>
			</Container>
		</section>
	);
};
